var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgContainerManagement = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Container_management",
    "data-name": "Container management",
    width: 20,
    height: 27.287,
    viewBox: "0 0 20 27.287",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_15",
    "data-name": "Subtraction 15",
    d: "M14.883,27.287H5.116A5.122,5.122,0,0,1,0,22.171V5.116A5.122,5.122,0,0,1,5.116,0h9.767A5.122,5.122,0,0,1,20,5.116V22.171A5.122,5.122,0,0,1,14.883,27.287ZM5.676,3A3.174,3.174,0,0,0,2.551,6.213V21.16a3.174,3.174,0,0,0,3.126,3.213h8.7A3.174,3.174,0,0,0,17.5,21.16V6.213A3.174,3.174,0,0,0,14.375,3Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_14",
    "data-name": "Subtraction 14",
    d: "M9.673,18.3H2.557A2.662,2.662,0,0,1,0,15.547V2.751A2.662,2.662,0,0,1,2.557,0H9.673A2.662,2.662,0,0,1,12.23,2.751v12.8A2.662,2.662,0,0,1,9.673,18.3ZM4.032,3.186A1.85,1.85,0,0,0,2.3,5.135V13.34a1.851,1.851,0,0,0,1.728,1.949H8.124A1.851,1.851,0,0,0,9.852,13.34V5.135A1.85,1.85,0,0,0,8.124,3.186Z",
    transform: "translate(3.885 4.495)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5373",
    "data-name": "Path 5373",
    d: "M1.212,0h2.87A1.409,1.409,0,0,1,5.293,1.545v6.5A1.409,1.409,0,0,1,4.081,9.593H1.212A1.409,1.409,0,0,1,0,8.049v-6.5A1.409,1.409,0,0,1,1.212,0Z",
    transform: "translate(7.354 8.847)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgContainerManagement, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ContainerManagement.a91db177.svg";
export { ForwardRef as ReactComponent };